import { endsWith, cond, equals, always, any, T, find, head } from 'ramda';
import { REACT_REMOTE_APP_ENVIRONMENT } from 'src/constants';
import SiteSettings from 'src/siteSetting';


export const getNamespaceId = () => {
  return SiteSettings.namespaceId()
};

export const getNamespaceName = () => {
  const data = (window as any).__lendsmart_preload;
  return data.slug;
};

export const getNameSpaceDisplayName = () => {
  return SiteSettings.generalAppTitle();
};

export const getStandardNamespaceName = () => { 
  const splitOnSuffix = (suffixes:any, str:any) => {
    const matchedSuffix = find((suffix:any) => endsWith(suffix, str), suffixes);
    return matchedSuffix ? str.split(matchedSuffix) : [str];
  };
  const suffixes = ['dev', 'uat'];
  return head(splitOnSuffix(suffixes,getNamespaceName()))
}


const isQASite = (n: string) => endsWith(n, getNamespaceName())

export const globalNamespace = (namespace: string) => {
  // TODO: this global namespace will be system for all environment for time being we are getting from 
  // .env only for development 
  return cond([
    [() => equals(REACT_REMOTE_APP_ENVIRONMENT, 'development'), always('system')],
    [() => any(isQASite, ['dev', 'uat']), always('systemdev')],
    [T, always('systemprod')]
  ])(namespace)
}

export const getGlobalNamespace = () => {
  return globalNamespace(getNamespaceName())
}